import { callAxios, formatError } from 'components/utils/FormatData';
import { Checkbox, makeStyles, TextField } from '@material-ui/core';
import { ClipLoader } from 'react-spinners';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { faCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import { genKey, setStorage } from 'components/utils/Storage';
import { isMobile } from 'react-device-detect';
import { useAlert } from 'react-alert';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import axios from 'axios';
import MyButton from 'components/form/MyButton';
import MyDialog from 'components/form/MyDialog';
import React, { useEffect, useState } from 'react';
import TopBar from 'components/layout/TopBar';

import { URL_API } from '../../constants/settings';
import useWindowSize from '../../hooks/useWindowSize';

const useStyles = makeStyles({
  label: {
    '& .MuiInputBase-input': {
      fontWeight: 'bold',
    },
    '& .MuiFormLabel-root': {
      fontSize: '20px',
    },
    '& .MuiCheckbox-root': {
      color: '#bb0060',
    },
  },
});
const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  padding: 20,
  margin: `0 0 10px 0`,
  background: '#ebeff3',
  borderBottom: isDragging ? '3px solid #0094ca' : 'none',
  display: 'flex',
  alignItems: 'center',
  ...draggableStyle,
});
const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? 'white' : 'white',
  width: '75vw',
  overflow: 'auto',
});
const getItems = (datas) => {
  const items = [];

  datas.map((d) => {
    items.push({
      id: String(d.id),
      libelle: d.libelle,
      ordre: d.ordre,
      avecCreationOT: d.avecCreationOT
    });
  });

  return items;
};

const ParamAcquitalReason = (props) => {
  const classes = useStyles();
  const alert = useAlert();
  const history = useHistory();
  const [width, height] = useWindowSize();
  const [loading, setLoading] = useState(true);
  const [motifs, setMotifs] = useState([]);
  const [componentHeight, setComponentHeight] = useState(height - (110 + document.getElementById('component-topbar')?.clientHeight ? document.getElementById('component-topbar').clientHeight : 0));
  const [content, setContent] = useState('');
  const [chooseMotif, setChooseMotif] = useState();
  const [dialogState, setDialogState] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [aMotif, setAMotif] = useState();
  const [newMotif, setNewMotif] = useState({
    libelle: '',
    avecCreationOT: false
  });
  const auth = useSelector(state => state["authentification"]);

  useEffect(() => {
    document.title = `SED - Motifs d'acquittement`;
    if (auth.profil !== 1 && auth.profil !== 2) {
      alert.error(`Vous n'êtes pas autorisé à accéder à cet écran`);
      history.push('/');
    }
  }, []);
  useEffect(() => {
    const heightTopBar = document.getElementById('component-topbar')?.clientHeight ? document.getElementById('component-topbar').clientHeight : 0;

    setComponentHeight(!isMobile ? height - (110 + heightTopBar) : height - (60 + heightTopBar));
  }, [width, height]);
  useEffect(() => {
    if (dialogState) {

      axios({ method: 'delete', url: URL_API + '/motifs/' + chooseMotif.id })
        .then(function () {
          alert.success(`Le motif d'acquittement [${chooseMotif.libelle}] a été supprimé avec succès`);
          fetchListAcquitalReason();
        })
        .catch(function (err) {
          formatError(alert, err);
        });

      setChooseMotif(null);
      setDialogState(null);
    }
  }, [dialogState]);
  useEffect(() => {
    if (props.wsStatus !== null) {
      fetchListAcquitalReason();
    }
  }, [props.wsStatus]);

  const fetchListAcquitalReason = () => {

    callAxios(props.wsStatus, "param_list_motifs", { method: 'get', url: URL_API + '/motifs' }, setLoading, alert)
    .then((res) => {
      setMotifs(getItems(res));
      setStorage(genKey("param_list_motifs"), res);
    });

  };
  const reorder = (list, startIndex, endIndex) => {

    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const itemsReoder = reorder(motifs, result.source.index, result.destination.index);
    majMotifs(itemsReoder);

  };
  const handleDeleteMotif = (motif) => {
    if (motif) {
      setChooseMotif(motif);
      setContent(`Êtes-vous sur de vouloir supprimer ce motif d'acquittement: ${motif.libelle}`);
      setOpenDialog(true);
    }
  };
  const majMotifs = (items) => {
    const listItemsMaj = [];
    const promiseTab = [];

    // Affichage du spinner
    setLoading(true);

    // Récupération des motifs à mettre à jour
    items.map((item, i) => {
      if ((i + 1) !== item.ordre) {
        listItemsMaj.push({
          avecCreationOT: item.avecCreationOT,
          id: item.id,
          libelle: item.libelle,
          ordre: (i + 1),
        });
      }
    });

    // Boucle de màj de l'ordre des motifs
    listItemsMaj.map((motif) => {
      promiseTab.push(axios({ method: 'put', url: URL_API + '/motifs/' + Number(motif.id), data: motif }));
    });

    Promise.all(promiseTab)
      .then(function () {
        alert.success('Les motifs d\'acquittement des alarmes ont été mise à jour');
        fetchListAcquitalReason();
      })
      .catch(function (err) {
        formatError(alert, err);
      });
  };
  const handleOnBlurAMotif = () => {
    axios({ method: 'put', url: URL_API + '/motifs/' + Number(aMotif.id), data: aMotif })
      .then(() => {
        alert.success('Le motif a bien été mis à jour en [' + aMotif.libelle + ']');
        setAMotif(null);
        fetchListAcquitalReason();
      })
      .catch((err) => {
        formatError(alert, err);
      });
  };
  const handleCreateNewMotif = () => {
    setLoading(true);

    if (newMotif.libelle !== '') {
      axios({ method: 'post', url: URL_API + '/motifs', data: { libelle: newMotif.libelle, avecCreationOT: newMotif.avecCreationOT, ordre: motifs.length + 1 } })
        .then(() => {
          alert.success('Le motif [' + newMotif.libelle + '] a bien été créé');
          setNewMotif({
            libelle: '',
            avecCreationOT: false
          });
          fetchListAcquitalReason();
        })
        .catch((err) => {
          formatError(alert, err);
        });
    } else {
      alert.error('Veuillez renseigner un motif avant de continuer');
      setLoading(false);
    }
  };
  const handleOnChangeWithCreateOT = (motif) => {
    axios({ method: 'post', url: URL_API + '/motifs', data: { id: motif.id, libelle: motif.libelle, ordre: motif.ordre, avecCreationOT: !motif.avecCreationOT } })
      .then(() => {
        fetchListAcquitalReason();
      })
      .catch((err) => {
        formatError(alert, err);
      });
  };

  return (
    <div id="parameters" className={!isMobile ? 'panel-contenu' : 'panel-contenu-mobile-tablette'} style={{ height: !isMobile ? height - 110 : height - 60 }}>

      <TopBar title="gestion des motifs d'acquittement des alarmes" className={!isMobile ? 'topbar-contenu' : 'topbar-contenu-mobile-tablette'}
        color={props.params.color}
        buttons={null} />

      <div className="composant-content-flex-start"
        style={{ height: componentHeight, overflow: 'auto', flexDirection: 'column', alignItems: 'center' }}>

        <ClipLoader
          color={'#0094ca'}
          loading={loading}
          css={'display: flex; position: absolute; top: 45%; left:0; right:0; margin:auto; z-index:150;'}
          size={50}
        />

        <div style={{ marginTop: '25px' }}>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" isDropDisabled={!props.wsStatus}>
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {motifs && motifs.map((motif, index) => (
                    <Draggable key={motif.id} draggableId={motif.id} index={index}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style,
                          )}
                        >
                          <div className="draggable-list-id">#{motif.id}</div>
                          <div className="draggable-list-content">
                            {
                              aMotif && aMotif.id === motif.id &&
                              <TextField
                                className={classes.label}
                                label=""
                                type="text"
                                value={aMotif.libelle}
                                onChange={(e) => setAMotif({ ...aMotif, libelle: e.target.value })}
                                onBlur={() => handleOnBlurAMotif()}
                                style={{ width: '75%', margin: 'auto' }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                autoComplete={'off'}
                              />
                            }
                            {
                              (!aMotif || (aMotif && aMotif.id !== motif.id)) && <span onClick={() => setAMotif(motif)}>{motif.libelle}</span>
                            }
                          </div>
                          <div className="draggable-list-actions">
                            <Checkbox
                              className={classes.label}
                              checked={motif.avecCreationOT}
                              onClick={() => handleOnChangeWithCreateOT(motif)}
                              disabled={!props.wsStatus}
                            />
                            <MyButton className="classic-button" type="button" href="#" iconCenter={{ icon: faTrash, type: 'fontAwesome' }}
                              styleCss={{ boxShadow: 'none', color: !props.wsStatus ? '#8ca0a8' : '#BB0060', height: '25px', margin: '10px', padding: '0', cursor: !props.wsStatus ? 'default' : 'cursor' }}
                              onClick={() => props.wsStatus ? handleDeleteMotif(motif) : null} />
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          <div className="row-center" style={{ margin: '0', background: '#ebeff3', padding: '25px 0', width: '75vw' }}>
            <TextField
              className={classes.label}
              label="Nouveau motif"
              type="text"
              value={newMotif.libelle}
              onChange={(e) => setNewMotif({ ...newMotif, libelle: e.target.value })}
              style={{ width: '70%', fontSize: '20px' }}
              InputLabelProps={{
                shrink: true,
              }}
              autoComplete={'off'}
              disabled={!props.wsStatus}
            />
            <div className="draggable-list-actions">
              <Checkbox
                className={classes.label}
                checked={newMotif.avecCreationOT}
                onClick={() => setNewMotif({ ...newMotif, avecCreationOT: !newMotif.avecCreationOT })}
                disabled={!props.wsStatus}
              />
              <MyButton className="classic-button" type="button" href="#" iconCenter={{ icon: faCheck, type: 'fontAwesome' }}
                styleCss={{ boxShadow: 'none', color: !props.wsStatus ? '#8ca0a8' : '#BB0060', height: '25px', margin: '10px', padding: '0', cursor: !props.wsStatus ? 'default' : 'cursor' }}
                onClick={props.wsStatus ? handleCreateNewMotif : null}
              />
            </div>
          </div>

        </div>

        <MyDialog open={openDialog} handleClose={setOpenDialog} title="Suppression d'un motif d'acquittement" content={content} dialog={setDialogState} />

      </div>
    </div >
  );

};

export default ParamAcquitalReason;